import _objectWithoutProperties from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import React, { useRef, useContext } from 'react';
import { TranslatorContext } from '@jutro/locale';
import { messages } from '../LookupField.messages';
import { GenericSelectComponents as components } from '../../GenericSelectControl/GenericSelectControl';
export const LookupMenu = _ref => {
  let children = _ref.children,
    props = _objectWithoutProperties(_ref, ["children"]);
  const translator = useContext(TranslatorContext);
  const showRecentBar = useRef(true);
  if (showRecentBar.current) {
    const _props$selectProps = props.selectProps,
      inputValue = _props$selectProps.inputValue,
      showRecent = _props$selectProps.showRecent;
    showRecentBar.current = !inputValue && showRecent;
  }
  const customStyles = props.selectProps.customStyles;
  return React.createElement(components.Menu, props, showRecentBar.current && React.createElement("div", {
    className: customStyles.recentBar
  }, translator(messages.recentlyViewed)), children);
};
LookupMenu.__docgenInfo = {
  componentName: "LookupMenu",
  packageName: "@jutro/components",
  description: "",
  displayName: "LookupMenu",
  methods: [],
  actualName: "LookupMenu"
};